import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Chat = (props: Icon): React.ReactElement => (
  <svg
    style={{ ...style(props.size, props.height), ...props.style }}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M13.6666667,3.99999995 C17.1641899,3.99999995 20,6.83581013 20,10.3333333 C20,13.8308565 17.1641899,16.6666667 13.6666667,16.6666667 L13.6666667,16.6666667 L13.5346667,16.6666667 L9.70313345,19.2213669 C9.28119394,19.5026599 8.72284279,19.2279875 8.67062327,18.7412283 L8.67062327,18.7412283 L8.66666665,18.6666667 L8.66666665,16.4386667 L8.5117401,16.395323 C5.93211808,15.623217 4.08187288,13.2720255 4.00264654,10.5175496 L4.00264654,10.5175496 L3.99999995,10.3333333 C3.99999995,6.83581013 6.83581013,3.99999995 10.3333333,3.99999995 L10.3333333,3.99999995 Z M13.6666667,5.33333329 L10.3333333,5.33333329 C7.57218981,5.33333329 5.33333329,7.57218981 5.33333329,10.3333333 C5.33333329,12.7638177 7.08204254,14.8276506 9.45046997,15.2503714 C9.76844846,15.3071248 9.99999999,15.5836632 9.99999999,15.9066667 L9.99999999,15.9066667 L9.99999999,17.42 L12.9635332,15.4452998 C13.0511426,15.3868936 13.1510144,15.3502788 13.2548465,15.3379691 L13.2548465,15.3379691 L13.3333333,15.3333333 L13.6666667,15.3333333 C16.4278102,15.3333333 18.6666667,13.0944768 18.6666667,10.3333333 C18.6666667,7.57218981 16.4278102,5.33333329 13.6666667,5.33333329 L13.6666667,5.33333329 Z M13.3333333,11.3333333 C13.7015232,11.3333333 14,11.6318102 14,12 C14,12.3418906 13.7426399,12.6236714 13.4110808,12.6621815 L13.3333333,12.6666667 L10.6666667,12.6666667 C10.2984768,12.6666667 9.99999999,12.3681898 9.99999999,12 C9.99999999,11.6581094 10.2573601,11.3763286 10.5889192,11.3378185 L10.6666667,11.3333333 L13.3333333,11.3333333 Z M15.3333334,8.66666665 C15.7015232,8.66666665 16,8.96514348 16,9.33333332 C16,9.67522388 15.7426399,9.95700476 15.4110808,9.99551483 L15.3333334,9.99999999 L8.66666665,9.99999999 C8.29847681,9.99999999 7.99999998,9.70152315 7.99999998,9.33333332 C7.99999998,8.99144276 8.2573601,8.70966187 8.58891923,8.6711518 L8.66666665,8.66666665 L15.3333334,8.66666665 Z"
        id="path-1-chat-conversation"
      ></path>
    </defs>
    <g
      id="icon-24x24px[16x16px]---line&amp;solid"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Atom/icon/communication/chat-conversation/line">
        <mask id="mask-2-chat-conversation" fill="white">
          <use xlinkHref="#path-1-chat-conversation"></use>
        </mask>
        <use
          id="Combined-Shape"
          fill="#FFFFFF"
          fillRule="nonzero"
          xlinkHref="#path-1-chat-conversation"
        ></use>
        <g
          id="Group"
          mask="url(#mask-2-chat-conversation)"
          fill={props.color || theme.palette.grey600}
        >
          <g id="🎨-color">
            <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
